import React, {useEffect} from 'react';
import {Card, Col, Row, Typography} from 'antd';
import {BarChartOutlined, BookOutlined, IdcardOutlined} from '@ant-design/icons';
import StudentLayout from '@/components/layout/student/studentLayout';
import {Link} from 'react-router-dom';
import {URLS} from "@/lib/urls";
import {useApiReadStudentDashboard} from "@/api/dashboard";
import RenderIf from "@/components/render-if";
import TextToHtml from "@/components/text-to-html";
import {useAuth} from "@/provider/AuthProvider";
import LowBudgetAlertPay from "@/components/low-budget-alert-pay/LowBudgetAlertPay";
import StudentWelcomeSection from "@/pages/student/dashboard/_section/StudentWelcomeSection";
import {APP_CLIENT} from "@/constants/config";
import {GradeSelectBox} from "@/pages/student/lessons/steps/ChooseGradePage";
import CampaignTemp from "@/pages/student/dashboard/_section/CampaignTemp";


const {Title} = Typography;

const navCards = [
    // {
    //     title: 'پروفایل',
    //     icon: <UserOutlined className={'text-blue-700 text-3xl'}/>,
    //     link: URLS.student.profile.dashboard,
    // },
    {
        title: 'کلاس‌های فعال من',
        icon: <i className={'icon-book-heart text-orange-700 text-3xl'}></i>,
        link: URLS.student.lessons.myLesson.list + '?filter=active',
    },
    {
        title: 'تاریخچه کلاس‌ها',
        icon: <i className={'icon-book text-orange-600 text-3xl'}></i>,
        link: URLS.student.lessons.myLesson.list + '?filter=all',
    },
    {
        title: 'انتخاب درس',
        icon: <BookOutlined className={'text-pink-700 text-3xl'}/>,
        link: URLS.student.lessons.take,
    },
    {
        title: 'غیبت‌ها',
        icon: <i className={'icon-user-xmark text-red-600 text-3xl'}></i>,
        link: URLS.student.absences.dashboard,
    },

    {
        title: 'گواهی‌نامه‌ها',
        icon: <IdcardOutlined className={'text-green-700 text-3xl'}/>,
        link: URLS.student.certifications.dashboard,
    },
    {
        title: 'شرکت در نظرسنجی',
        icon: <BarChartOutlined className={'text-blue-700 text-3xl'}/>,
        link: URLS.student.survey.publicSurvey,
    },
    // {
    //     title: 'تراکنش‌های مالی و شارژ حساب',
    //     icon: <WalletOutlined className={'text-yellow-700 text-3xl'}/>,
    //     link: URLS.student.billing.dashboard,
    // },
    // {
    //     title: 'اقساط',
    //     icon: <DollarOutlined className={'text-yellow-700 text-3xl'}/>,
    //     link: URLS.student.installments.dashboard,
    // },

    // {
    //     title: 'آموزش مجازی',
    //     icon: <span className={'icon-book-sparkles text-orange-700 text-3xl'}/>,
    //     link: URLS.lms.dashboard,
    // },


];


function StudentDashboardPage() {

    const {data: rawDashboard, isPending: isPendingDashboard} = useApiReadStudentDashboard()

    const {setDashboard, dashboard} = useAuth();

    useEffect(() => {
        if (rawDashboard?.data?.data) {
            setDashboard(rawDashboard?.data?.data);
        }
    }, [rawDashboard]);


    return (
        <StudentLayout pageTitle={'داشبورد فراگیران'}>
            <StudentWelcomeSection/>
            <LowBudgetAlertPay budget={dashboard?.budget}/>

            <div>
                <RenderIf condition={APP_CLIENT === 'quranlove'}>
                    {/*<CampaignTemp />*/}
                </RenderIf>

                <RenderIf condition={APP_CLIENT === 'quranlove' || APP_CLIENT === 'edu'}>
                    <div className={'my-2'}>
                        <GradeSelectBox/>
                    </div>
                </RenderIf>
                <RenderIf condition={APP_CLIENT !== 'quranlove' && APP_CLIENT !== 'edu'}>
                    {/* Navigation Cards */}
                    <Row gutter={[24, 24]} justify="" className={'mb-4'}>
                        {navCards.map(card => (
                            <Col xs={24} sm={12} md={8} lg={6} key={card.title}>
                                <Link to={card.link}>
                                    <Card hoverable className={'text-center rounded-2xl'}>
                                        {card.icon}
                                        <div className={'mt-2 font-bold text-l'}>{card.title}</div>
                                    </Card>
                                </Link>
                            </Col>
                        ))}
                    </Row>
                </RenderIf>

                <RenderIf condition={dashboard?.billboard}>
                    <Card title="تابلو اعلانات" className={'rounded-2xl'}>
                        <TextToHtml>{dashboard?.billboard}</TextToHtml>
                    </Card>
                </RenderIf>
            </div>
        </StudentLayout>
    );
}

export default StudentDashboardPage;